import moment from 'moment'

export const tabelasRelatorioFilaMethods = {
  obtemDadosPrimariosTabelas(objeto) {
    let atendidas
    let porcentagemAtendidas
    let abandonadas
    let porcentagemAbandonadas
    let transbordo
    let porcentagemTimeout
    let total
    let tmc
    let tma
    let tme
    let tmab

    if (typeof objeto.atendidas !== 'undefined') {
      atendidas = Number(objeto.atendidas)
    } else {
      atendidas = 0
    }

    if (typeof objeto.Abandonadas !== 'undefined') {
      abandonadas = Number(objeto.Abandonadas)
    } else {
      abandonadas = 0
    }

    if (typeof objeto.timeout !== 'undefined') {
      transbordo = Number(objeto.timeout)
    } else {
      transbordo = 0
    }

    total = atendidas + abandonadas + transbordo

    if (total === 0) {
      porcentagemAtendidas = 0
      porcentagemAbandonadas = 0
      porcentagemTimeout = 0
    } else {
      porcentagemAtendidas = (atendidas / total) * 100
      porcentagemAbandonadas = (abandonadas / total) * 100
      porcentagemTimeout = (transbordo / total) * 100
    }

    if (typeof objeto.mediaTempoDeChamada !== 'undefined') {
      tmc = objeto.mediaTempoDeChamada
    } else {
      tmc = '00:00:00'
    }

    if (typeof objeto.mediaTempoDeAtendimento !== 'undefined') {
      tma = objeto.mediaTempoDeAtendimento
    } else {
      tma = '00:00:00'
    }

    if (typeof objeto.mediaEspera !== 'undefined') {
      tme = objeto.mediaEspera
    } else {
      tme = '00:00:00'
    }
    if(typeof objeto.mediaAbandono !== 'undefined'){
      tmab = objeto.mediaAbandono
    }else{
      tmab = '00:00:00'
    }

    return {
      atendidas,
      abandonadas,
      transbordo,
      porcentagemAtendidas,
      porcentagemAbandonadas,
      porcentagemTimeout,
      total,
      tma,
      tmc,
      tme,
      tmab    
    }
  },

  preencheTabelaLigacoesPorHora(arrayLigacoes) {
    this.itemsHora = []
    arrayLigacoes.forEach(dado => {
      let {
        atendidas,
        abandonadas,
        transbordo,
        porcentagemAtendidas,
        porcentagemAbandonadas,
        porcentagemTimeout,
        total,
        tma,
        tmc,
        tme,
        tmab,
      } = this.obtemDadosPrimariosTabelas(dado)

      this.itemsHora.push({
        data: dado.data,
        hora: dado.hora,
        total,
        atendidas: `${atendidas} (${porcentagemAtendidas.toFixed(0)}%)`,
        abandonadas: `${abandonadas} (${porcentagemAbandonadas.toFixed(0)}%)`,
        transbordo: `${transbordo} (${porcentagemTimeout.toFixed(0)}%)`,
        tmc,
        tma,
        tme,
        tmab,
      })
    })
  },

  preencheTabelaLigacoesPorDia(objetoLigacoes) {
    this.itemsDia = []
    let keys = Object.keys(objetoLigacoes)
    let values = Object.values(objetoLigacoes)
    const newKeys = keys.map(data => moment(data, 'DD-MM-YYYY').format('DD/MM/YYYY'))

    for (let i = 0; i < keys.length; i++) {
      let {
        atendidas,
        abandonadas,
        transbordo,
        porcentagemAtendidas,
        porcentagemAbandonadas,
        porcentagemTimeout,
        total,
        tma,
        tmc,
        tme,
        tmab,
      } = this.obtemDadosPrimariosTabelas(values[i])

      this.itemsDia.push({
        data: newKeys[i],
        total,
        atendidas: `${atendidas} (${porcentagemAtendidas.toFixed(0)}%)`,
        abandonadas: `${abandonadas} (${porcentagemAbandonadas.toFixed(0)}%)`,
        transbordo: `${transbordo} (${porcentagemTimeout.toFixed(0)}%)`,
        tmc,
        tma,
        tme,
        tmab,
      })
    }
  },
}
